"use strict";
const STYLE_ID = "stc-eab-ioc-bot-overlay-styles";
export function ensureIocBotOverlayStyles() {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    eab-ioc-bot.overlay {
      z-index: 888888888;
      position: fixed;
      top: var(--kb-top, 0);
      bottom: var(--kb-bottom, 0);
      left: auto;
      right: 0;
      width: var(--kb-attached-width, 560px);
      min-width: 320px;
      max-width: 85vw;
      padding: 0;
      border-radius: 0;
      box-shadow: -4px 0 16px 0 rgba(0, 0, 0, 0.12);
      border-left: 1px solid #ddd;
      will-change: transform;
      animation: kb-slide-in-right 320ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
    }
    eab-ioc-bot.overlay.kb-closing {
      animation: kb-slide-out-right 380ms cubic-bezier(0.4, 0, 0.8, 1) both;
    }
    @media (max-width: 600px) {
      eab-ioc-bot.overlay {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100% !important;
        min-width: 0;
        max-width: 100%;
        border-left: none;
        box-shadow: none;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      eab-ioc-bot.overlay,
      eab-ioc-bot.overlay.kb-closing {
        animation: none;
        will-change: auto;
      }
    }
  `;
  document.head.appendChild(style);
}
